<template>
    <div v-show="visible">
        <el-dialog title="查看附件" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="600px">
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                height="200"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border fit highlight-current-row>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="附件">
                    <template slot-scope="scope">
                        <div v-if="scope.row.fileType == 1">
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.url" lazy="loading"
                                    style="height:550px; width:550px"/>
                                <img slot="reference" :src="scope.row.url"  lazy="loading" :alt="scope.row.url" style="height: 100px;width:100px">
                            </el-popover>
                        </div>
                        <div v-else-if="scope.row.fileType == 2">
                            <a target="_blank" :href="scope.row.url">点击查看附件</a>
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
    </div>
</template>

<script>
    import http from '@/common/http'

    export default {
        name:"",
        data(){
            return{
                visible:false,
                loading:false,
                data:[]
            }
        },
        components: {
        },
        created:function () {
        },
        mounted:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                let images = data.image1Url?(data.image1Url.split(';')):[]
                let files = data.image2Url?(data.image2Url.split(';')):[]

                // 图片数组
                for(let i=0;i<images.length;i++){
                    let tempImage = {}
                    tempImage.fileType = 1
                    tempImage.url = images[i]
                    this.data.push(tempImage)
                }

                // 文件数组
                for(let i=0;i<files.length;i++){
                    let tempFile = {}
                    tempFile.fileType = 2
                    tempFile.url = files[i]
                    this.data.push(tempFile)
                }
                console.log(JSON.stringify(this.data))
            },
            indexMethod(index) {
                return index+1;
            },
            dialogClose(done){
                done();
                this.$reload;
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/notice/noticeRelease/fileInfo.vue